export default __webpack_public_path__ + "ab594dc176f98af6a2960bb0981f182b.png";